// here we modify series

import IndexModifier from "../../modifiers/IndexModifier";
import RateOfChangeModifier from "../../modifiers/RateOfChangeModifier";
import DifferenceModifier from "../../modifiers/DifferenceModifier";
import InterpolateLinearModifier from "../../modifiers/InterpolateLinearModifier";
import InterpolateConstantModifier from "../../modifiers/InterpolateConstantModifier";
import ExtrapolateConstantModifier from "../../modifiers/ExtrapolateConstantModifier";
import ExtrapolateLinearModifier from "../../modifiers/ExtrapolateLinearModifier";
import DatePeriod from "../../DatePeriod";
import LimitDataModifier from "../../modifiers/LimitDataModifier";
import MovingAverageModifier from "../../modifiers/MovingAverageModifier";
import http from "../../http";

function getModifier(modifier) {
    if (modifier.name === 'index') {
        return new IndexModifier(modifier.parameters);
    }
    if (modifier.name === 'roc') {
        return new RateOfChangeModifier(modifier.parameters);
    }
    if (modifier.name === 'difference') {
        return new DifferenceModifier(modifier.parameters);
    }
    if (modifier.name === 'interpolate_linear') {
        return new InterpolateLinearModifier(modifier.parameters);
    }
    if (modifier.name === 'interpolate_constant') {
        return new InterpolateConstantModifier(modifier.parameters);
    }
    if (modifier.name === 'extrapolate_constant') {
        return new ExtrapolateConstantModifier(modifier.parameters);
    }
    if (modifier.name === 'extrapolate_linear') {
        return new ExtrapolateLinearModifier(modifier.parameters);
    }
    if (modifier.name === 'limit') {
        return new LimitDataModifier(modifier.parameters);
    }
    if (modifier.name === 'mvag') {
        return new MovingAverageModifier(modifier.parameters);
    }
}

export default {
    state: {
        edit: false,
        copy: false,
        modifier: null,
        affectedSeries: [],
        mySeries: [], // TODO RENAME! this are temporary series
    },

    actions: {
        // begin edit, copy the state?
        edit({state}) {
            state.edit = true;
        },

        // set edit state = current state
        save({state, commit, rootState, dispatch}) {
            state.edit = false;
            /**
             * update: function (action, ids, parameters) {
             *    this.$store.dispatch('update', {action: action, ids: ids, parameters: parameters});
             * },
             */
            if (state.mySeries.length > 0) {
                return dispatch('updateMySeries');
            }

            if (!state.copy) {
                dispatch('update', {
                    action: state.modifier.name,
                    ids: state.affectedSeries,
                    parameters: state.modifier.parameters,
                });
            }

            if (state.copy) {
                dispatch('updateAsNew');
            }
        },

        // revert back to last save
        abort({state}) {
            state.edit = false;
            state.mySeries = [];
        },

        setModifier({state}, parameters) {
            state.edit = true;
            state.modifier = parameters.modifier;
            state.affectedSeries = parameters.ids;
        },

        toggleCopy({state}) {
            state.copy = !state.copy;
        },

        updateMySeries({commit, state, getters, rootState}) {
            state.loading = true;
            http
                .post("/panels/" + rootState.id, {
                    _method: 'patch',
                    periodicity: rootState.periodicity,
                    custom_series: state.mySeries,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },

        updateAsNew({commit, state, getters, rootState}) {
            state.loading = true;
            http
                .post("/panels/" + rootState.id, {
                    _method: 'patch',
                    action: state.modifier.name,
                    periodicity: rootState.periodicity,
                    ids: state.affectedSeries,
                    parameter: state.modifier.parameters,
                    copy: true,
                })
                .then(function (response) {
                    commit('storeRaw', response);
                })
                .catch(function (error) {
                    state.error = error;
                });
        },

        tempSeries({state}, series) {
            state.mySeries = series;
        },
    },

    getters: {
        tempSeries: (state, getters) => {
            if (!state.edit || !state.copy) {
                return [];
            }

            let data = [];
            state.affectedSeries.forEach(function (id) {
                data.push(_.cloneDeep(getters.preCompute[id]));
            });

            return data
                .map(function (item) {

                    item.data = state.modifier.compute(item.data, item.periodicity);

                    return item;
                })
        },

        timeSeries: (state, getters) => {
            // modify for highcharts
            return getters.compute
                .map(function (item) {
                    const data = item.data.map(function (field) {
                        return [Date.parse(field.time), field.value];
                    });

                    return {
                        name: item.name,
                        data: data,
                        color: item.color,
                        yAxis: getters.yAxis.findIndex(function (foo) {
                            return foo === item.unit;
                        }),
                    };
                });
        },

        yAxis: (state, getters) => {
            if (!getters.hasData) {
                return [];
            }
            return getters.compute
                .map(function (data) {
                    return data.unit;
                }).sort().filter(function (item, pos, ary) {
                    return !pos || item !== ary[pos - 1];
                }).map(function (axis) {
                    return axis;
                });
        },

        csv: (state, getters) => {

            if (getters.compute.length === 0) {
                return '';
            }

            // extra times from all series
            const min = getters.compute.map(function (item) {
                return item.data[0].time;
            }).sort()[0];

            const maxList = getters.compute.map(function (item) {
                return item.data[item.data.length - 1].time;
            }).sort();

            const max = maxList[maxList.length - 1];

            const interval = getters.compute[0].periodicity;

            const dates = DatePeriod.range(min, max, interval);

            let result = [];

            result.push(['Date']);

            _.forEach(dates, function (day) {
                result.push([day]);
            });

            _.forEach(getters.compute, function (item, key) {

                result[0][key + 1] = `"${item.name}"`;

                _.forEach(item.data, function (point) {
                    const position = dates.indexOf(point.time);
                    result[position + 1][key + 1] = point.value;
                });

            });

            return result.map(function (item) {
                return item.join(',');
            }).join("\n");
        },
        preCompute: (state, getters, rootState, rootGetters) => {
            if (!rootGetters.hasData) {
                return [];
            }

            let data = _.cloneDeep(rootState.rawData.data[rootState.periodicity].data);

            return data
                .concat(rootState.rawData.data[rootState.periodicity].aggregates)
                .concat(state.mySeries)
                // hide invisible items
                .filter(function (item) {
                    return item.visible;
                })
                // apply modifiers
                .map(function (item) {
                    // backwards compatibility
                    if (item.modifiers === undefined) {
                        return item;
                    }

                    item.modifiers.map(function (modifier) {
                        const mod = getModifier(modifier);
                        item.data = mod.compute(item.data, item.periodicity);
                    });

                    return item;
                })
        },
        compute: (state, getters, rootState) => {
            let data = _.cloneDeep(getters.preCompute);

            return data
            // apply modifier under edit
                .concat(getters.tempSeries)
                .map(function (item) {
                    if (!state.edit || state.copy) {
                        return item;
                    }

                    item.data = state.modifier.compute(item.data, item.periodicity);

                    return item;
                })
                // apply colors
                .map(function (item, key) {
                    item.color = rootState.colors[key % 10];
                    return item;
                })
        },
        rows: (state, getters) => {
            if (!getters.hasData) {
                return [];
            }

            return getters.compute;
        },
        times:
            (state, getters) => {
                if (!getters.hasData) {
                    return [];
                }

                let times = [];
                getters.compute.forEach(function (series) {
                    series.data.forEach(function (item) {
                        times.push(item.time);
                    })
                });

                return _.uniq(times).sort().reverse();
            },
    },

}
